import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { apiSlice } from './api/apiSlice';
import { userApiSlice } from './api/users/userApiSlice'; 
import { profileApiSlice } from './api/profiles/profileApiSlice'; 
import { publictionApiSlice } from './api/publications/publicationApiSlice';
import { businessRequestsApiSlice } from './api/businessRequests/businessRequestsApiSlice';
import { profileClaimApiSlice } from './api/profileClaim/profileClaimApiSlice';

const store = configureStore({
  reducer: {
    ...rootReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [userApiSlice.reducerPath]: userApiSlice.reducer, 
    [profileApiSlice.reducerPath]: profileApiSlice.reducer, 
    [publictionApiSlice.reducerPath]: publictionApiSlice.reducer,
    [businessRequestsApiSlice.reducerPath]: businessRequestsApiSlice.reducer,
    [profileClaimApiSlice.reducerPath]: profileClaimApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = [...getDefaultMiddleware(), apiSlice.middleware, userApiSlice.middleware,profileApiSlice.middleware,publictionApiSlice.middleware,businessRequestsApiSlice.middleware,profileClaimApiSlice.middleware];
    return middleware;
  },
});

export default store;
